export default class PageMenu {
    constructor($state, $rootScope) {
        this._state = $state;
        this._rootScope = $rootScope;

        this.items = {
            dashboard: [
                {
                    translate_key: "DASHBOARD:UPLOAD_SUBSCRIBERS_BTN",
                    tooltipsKeys: "DASHBOARD:TOOLTIP",
                    state: "subscriber.import",
                    hideFor: 'Sogeti|Sogeti Admin|Subscriber viewer|Campaign viewer'
                },
                {
                    translate_key: "DASHBOARD:NEW_CAMPAIGN_BTN",
                    tooltipsKeys: "DASHBOARD:TOOLTIPS",
                    state: "campaign.create",
                    hideFor: 'Sogeti|Sogeti Admin|Subscriber viewer|Campaign viewer'
                },
                {
                    translate_key: "EVENT:INDEX:NEW_EVENT",
                    tooltipsKeys: "EVENT:INDEX:NEW_EVENT_TOOLTIP",
                    state: "event.create",
                    role: 'Sogeti|Sogeti Admin'
                }
            ],
            campaign: [
                {
                    translate_key: "CAMPAIGN:INDEX:NEW_EMAIL",
                    tooltipKey: "CAMPAIGN:INDEX:TOOLTIP",
                    state: "campaign:newEmail",
                    hideFor: 'Campaign viewer'
                },
                {
                    translate_key: "CAMPAIGN:INDEX:NEW_SMS",
                    tooltipKey: "CAMPAIGN:INDEX:TOOLTIPS",
                    state: "campaign:newSMS",
                    hideFor: 'Campaign viewer'
                }
            ],
            subscriber: [
                {
                    translate_key: "SUBSCRIBER:INDEX:IMPORT",
                    tooltipKey: "SUBSCRIBER:INDEX:TOOLTIP",
                    state: "subscriber.import",
                    hideFor: 'Subscriber viewer'
                },
                {
                    translate_key: "SUBSCRIBER:INDEX:CUSTOM_FIELDS",
                    tooltipKey: "SUBSCRIBER:INDEX:TOOLTIPS",
                    state: "subscriber.groups",
                    hideFor: 'Subscriber viewer'
                },
                {
                    translate_key: "SUBSCRIBER:INDEX:WIDGET",
                    tooltipKey: "SUBSCRIBER:INDEX:TOOLTIPSS",
                    state: "subscriberForm.index",
                    hideFor: 'Subscriber viewer'
                }
            ],
            tag: [
                {
                    translate_key: "TAG:INDEX:NEW_TAG",
                    tooltipKey: "TAG:INDEX:TOOLTIP",
                    state: "tag.create"
                },
                {
                    translate_key: "TAG:INDEX:NEW_SMART_TAG",
                    tooltipKey: "TAG:INDEX:TOOLTIPS",
                    state: "filter.create"
                }
            ],
            template: [{
                translate_key: "TEMPLATE:INDEX:ORDER",
                tooltipKey: "TEMPLATE:INDEX:ORDER_TIP",
                state: "template.order"
            },
                {
                    translate_key: "TEMPLATE:INDEX:NEW_TEMPLATE",
                    tooltipKey: "TEMPLATE:INDEX:NEW_TEMPLATE_TIP",
                    state: "template.create"
                }
            ],
            automation: [
                {
                    translate_key: "AUTOMATION:INDEX:NEW_AUTOMATION",
                    tooltipKey: "AUTOMATION:INDEX:TOOLTIP",
                    state: "automation.create"
                }
            ],
            event: [
                {
                    translate_key: "EVENT:INDEX:NEW_EVENT",
                    tooltipsKeys: "EVENT:INDEX:NEW_EVENT_TOOLTIP",
                    state: "event.create"
                }
            ]
        };

        this.buttonActionMap = {
            'automation.create': 'automation:newAutomation',
            'tag.create': 'tag:newTag',
            'campaign:newSMS': 'campaign:newSMS',
            'campaign:newEmail': 'campaign:newEmail',
            'event.create': 'event:newEvent'
        };
        
        this.dropDown = true;
        this.active = true;
    };

    getItems() {
        return this.items;
    };

    getActive() {
        return this.active;
    };

    getDropDownMenu() {
        return this.dropDown;
    };

    setDropDownMenu(use) {
        this.dropDown = use;
    };

    setActive(name) {
        this.active = this.items[name];
    };

    route(state) {
        var action = this.buttonActionMap[state];
        action ? this._rootScope.$emit(action) : this._state.go(state);
    };
};
